module.exports = __webpack_public_path__ + "static/media/CodeBotLabs_Logo-Icon-happy-256.f207d4b7.png";